module.exports = __webpack_public_path__ + "img/american_credit_apply_in_minutes.12a1f11.png";